import React from "react";
import { Box, Button, Heading, Text } from "grommet";
import { Checkbox, CheckboxSelected } from "grommet-icons";

import { InstObject } from "../config/types";
import {
    selectedInstsKeptR,
    selectedInstsR,
} from "../recoils/selectedInsts";
import { useRecoilState } from "recoil";

const AInstCard = (props: any) => {
    let primaryname = props.inst.primaryname;
    const [ready, setReady] = React.useState(false);
    const [namesText, setNamesText] = React.useState<string>("");
    const [selected, setSelected] = React.useState(false);

    // state from recoil
    const [selectedInsts, setSelectedInsts] =
        useRecoilState(selectedInstsR);
    const [selectedInstsKept, setSelectedInstsKept] =
        useRecoilState(selectedInstsKeptR);

    React.useEffect(() => {
        let names = props.names;
        // console.log("AInstCard", names);
        let pnames: string[] = [];
        names.forEach((name: any) => {
            if (
                name.name_full !== "" &&
                name.name_full !== "nan" &&
                name.name_full !== primaryname &&
                name.name_full !== undefined
            ) {
                pnames.push(name.name_full);
            }
        });
        // setInstNames(pnames);
        setNamesText(pnames.join(", "));
        //   console.log(names, pnames, namesText);
        setReady(true);
    }, [props.names]);
    React.useEffect(() => {
        if (ready) {
            let inst: InstObject = props.inst;
            // console.log('AInstCard', inst.inst_id, selectedInsts)
            if (
                selectedInsts.findIndex(
                    (p) => p.inst_id === inst.inst_id
                ) < 0
            ) {
                setSelected(false);
            } else {
                setSelected(true);
            }
        }
    }, [ready, selectedInsts]);

    return (
        <Box
            width="full"
            style={{ minHeight: "50px" }}
            round="5px"
            margin={{ vertical: "2px" }}
            background={
                selected
                    ? {
                          color: "rgba(240,240,240,0.1)",
                          opacity: 0.8,
                      }
                    : { color: "rgba(250,250,250,0.1)" }
            }
            hoverIndicator
            direction="row"
            align="center"
            justify="start"
            focusIndicator={false}
            onClick={() => {
                setSelected(!selected);
                let inst: InstObject = props.inst;
                if (selected) {
                    setSelectedInsts(
                        selectedInsts.filter(
                            (p) => p.inst_id !== inst.inst_id
                        )
                    );
                    setSelectedInstsKept(
                        selectedInstsKept.filter(
                            (p) => p.inst_id !== inst.inst_id
                        )
                    );
                } else {
                    setSelectedInsts([...selectedInsts, inst]);
                    setSelectedInstsKept([...selectedInstsKept, inst]);
                }
            }}
        >
            <Box
                style={{ minWidth: "30px", maxWidth: "30px" }}
                margin="10px"
                focusIndicator={false}
            >
                {selected ? (
                    <CheckboxSelected size="15px" color={"rgb(255,102,114)"} />
                ) : (
                    <Checkbox size="15px" />
                )}
            </Box>
            <Box
                direction="row"
                align="start"
                style={{ minWidth: "70px" }}
                margin={{ horizontal: "10px" }}
            >
                <Text
                    size="small"
                    weight="bold"
                    color={selected ? "rgb(18,44,87)" : "rgb(0,0,0,0.6)"}
                >
                    {primaryname}
                </Text>
            </Box>
            <Box direction="row" align="start" margin={{ horizontal: "10px" }}>
                <Text
                    size="small"
                    color={selected ? "rgb(18,44,87)" : "rgb(0,0,0,0.6)"}
                >
                    {namesText}
                </Text>
            </Box>
        </Box>
    );
};

export default AInstCard;
